// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as ReactUnicons from "@iconscout/react-unicons";
function intOfSize(size) {
  if (typeof size !== "number") {
    return size._0;
  }
  switch (size) {
    case /* Base */0:
      return 24;
    case /* Half */1:
      return 12;
    case /* Double */2:
      return 48;
    case /* Triple */3:
      return 96;
  }
}
function styleOfSize(size) {
  return {
    height: CSS$Showside.intToPx(intOfSize(size)),
    width: CSS$Showside.intToPx(intOfSize(size))
  };
}
var Impl = {};
function Unicons$UilAngleLeftB(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilAngleLeftB, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilAngleLeftB.displayName = "Unicons.UilAngleLeftB";
var UilAngleLeftB = {
  Impl: Impl,
  make: Unicons$UilAngleLeftB
};
var Impl$1 = {};
function Unicons$UilAngleRightB(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilAngleRightB, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilAngleRightB.displayName = "Unicons.UilAngleRightB";
var UilAngleRightB = {
  Impl: Impl$1,
  make: Unicons$UilAngleRightB
};
var Impl$2 = {};
function Unicons$UilArrowRight(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilArrowRight, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilArrowRight.displayName = "Unicons.UilArrowRight";
var UilArrowRight = {
  Impl: Impl$2,
  make: Unicons$UilArrowRight
};
var Impl$3 = {};
function Unicons$UilCheck(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilCheck, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilCheck.displayName = "Unicons.UilCheck";
var UilCheck = {
  Impl: Impl$3,
  make: Unicons$UilCheck
};
var Impl$4 = {};
function Unicons$UilEstate(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilEstate, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilEstate.displayName = "Unicons.UilEstate";
var UilEstate = {
  Impl: Impl$4,
  make: Unicons$UilEstate
};
var Impl$5 = {};
function Unicons$UilExclamationTriangle(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilExclamationTriangle, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilExclamationTriangle.displayName = "Unicons.UilExclamationTriangle";
var make = React.memo(Unicons$UilExclamationTriangle);
var UilExclamationTriangle = {
  Impl: Impl$5,
  make: make
};
var Impl$6 = {};
function Unicons$UilExternalLinkAlt(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilExternalLinkAlt, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilExternalLinkAlt.displayName = "Unicons.UilExternalLinkAlt";
var make$1 = React.memo(Unicons$UilExternalLinkAlt);
var UilExternalLinkAlt = {
  Impl: Impl$6,
  make: make$1
};
var Impl$7 = {};
function Unicons$UilLinkAlt(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilLinkAlt, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilLinkAlt.displayName = "Unicons.UilLinkAlt";
var UilLinkAlt = {
  Impl: Impl$7,
  make: Unicons$UilLinkAlt
};
var Impl$8 = {};
function Unicons$UilMinus(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilMinus, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilMinus.displayName = "Unicons.UilMinus";
var UilMinus = {
  Impl: Impl$8,
  make: Unicons$UilMinus
};
var Impl$9 = {};
function Unicons$UilPause(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilPause, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilPause.displayName = "Unicons.UilPause";
var UilPause = {
  Impl: Impl$9,
  make: Unicons$UilPause
};
var Impl$10 = {};
function Unicons$UilPlay(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilPlay, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilPlay.displayName = "Unicons.UilPlay";
var UilPlay = {
  Impl: Impl$10,
  make: Unicons$UilPlay
};
var Impl$11 = {};
function Unicons$UilPlus(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilPlus, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilPlus.displayName = "Unicons.UilPlus";
var UilPlus = {
  Impl: Impl$11,
  make: Unicons$UilPlus
};
var Impl$12 = {};
function Unicons$UilSlidersVAlt(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilSlidersVAlt, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilSlidersVAlt.displayName = "Unicons.UilSlidersVAlt";
var UilSlidersVAlt = {
  Impl: Impl$12,
  make: Unicons$UilSlidersVAlt
};
var Impl$13 = {};
function Unicons$UilSync(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilSync, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilSync.displayName = "Unicons.UilSync";
var UilSync = {
  Impl: Impl$13,
  make: Unicons$UilSync
};
var Impl$14 = {};
function Unicons$UilTimes(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilTimes, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilTimes.displayName = "Unicons.UilTimes";
var UilTimes = {
  Impl: Impl$14,
  make: Unicons$UilTimes
};
var Impl$15 = {};
function Unicons$UilTrash(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilTrash, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilTrash.displayName = "Unicons.UilTrash";
var UilTrash = {
  Impl: Impl$15,
  make: Unicons$UilTrash
};
var Impl$16 = {};
function Unicons$UilVectorSquare(Props) {
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  return React.createElement(ReactUnicons.UilVectorSquare, {
    className: CSS$Showside.prefix(""),
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilVectorSquare.displayName = "Unicons.UilVectorSquare";
var UilVectorSquare = {
  Impl: Impl$16,
  make: Unicons$UilVectorSquare
};
var Impl$17 = {};
function Unicons$UilVolume(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilVolume, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilVolume.displayName = "Unicons.UilVolume";
var UilVolume = {
  Impl: Impl$17,
  make: Unicons$UilVolume
};
var Impl$18 = {};
function Unicons$UilVolumeMute(Props) {
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(ReactUnicons.UilVolumeMute, {
    className: className,
    size: intOfSize(size),
    style: styleOfSize(size)
  });
}
Unicons$UilVolumeMute.displayName = "Unicons.UilVolumeMute";
var UilVolumeMute = {
  Impl: Impl$18,
  make: Unicons$UilVolumeMute
};
export { intOfSize, styleOfSize, UilAngleLeftB, UilAngleRightB, UilArrowRight, UilCheck, UilEstate, UilExclamationTriangle, UilExternalLinkAlt, UilLinkAlt, UilMinus, UilPause, UilPlay, UilPlus, UilSlidersVAlt, UilSync, UilTimes, UilTrash, UilVectorSquare, UilVolume, UilVolumeMute };
/* make Not a pure module */